import React from "react"
import useFileUpload from "hooks/useFileUpload"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"

interface FileUploadButtonProps extends CustomButtonProps {
  path?: string
  value?: any
  onChange?: any
}
const FileUploadButton = ({
  value,
  path,
  onChange,
  ...otherProps
}: FileUploadButtonProps) => {
  const arr = useFileUpload("test", {
    onCompleted(files: any) {
      onChange(path, files)
    },
  })
  const setFiles: any = arr?.[1]

  return (
    <div data-icon="&#x1F50D;" className="vt-custom-file-uploader">
      {/* <label className="vt-file-input-label" htmlFor="file">
        Test
      </label> */}
      <CustomButton
        icon="paperclip"
        dark
        text="Select Photos"
        {...otherProps}
      />
      <input id="file" type="file" multiple onChange={setFiles} />
    </div>
  )
}

export default FileUploadButton
